import React from 'react';
import Layout from '../../components/Layout';
import BecomeAPro from './BecomeAPro';

const title = 'Become a Pro or Company — BestHand';
const description =
  'Join BestHand as an individual pro (small jobs, your own schedule, fast pay) or as a company (large projects, competing quotes, milestone escrow). iOS & Android.';

function action() {
  return {
    title,
    description,
    component: (
      <Layout>
        <BecomeAPro />
      </Layout>
    ),
  };
}

export default action;
